/* eslint-disable @typescript-eslint/unbound-method */
import { Instrument as InstrumentBase } from '../../bases/instrument';
import * as CONSTANTS from './constants';
import { globalScope } from '../../window/browser';
import { Aggregator } from './aggregator';
import { getConfigurationValue } from '../../state/init';

export class Instrument extends InstrumentBase {
  static featureName = CONSTANTS.FEATURE_NAME;

  constructor() {
    const aggregator = new Aggregator();

    super(aggregator, Instrument.featureName);
    this.start = this.start.bind(this);

    if (this.auto) {
      this.start();
    }

    if (this.loadFunctions) {
      this.loadPublicFunctions();
    }
  }

  loadPublicFunctions() {
    if (globalScope.WMANS) {
      globalScope.WMANS.resource_timing = {};
      globalScope.WMANS.resource_timing.start = this.start;
    }
  }

  start() {
    void import('./module')
      .then(({ Module }) => {
        const config = getConfigurationValue(
          `instruments.features.${Instrument.featureName}.mapped_attributes`,
        );

        this.module = new Module(this.aggregator, config);
        this.module.start();
      })
      .catch(console.error);
  }
}
